import { inject } from '@angular/core';
import {
    CanActivateFn,
    Router,
} from '@angular/router';

import { AuthService } from '../../features/authentication/services/auth.service';

export interface AuthorizationOptions {
    roles?: string[];
    permissions?: string[];
    requireAll?: boolean;
}

export function authGuard(
    options: AuthorizationOptions,
): CanActivateFn {

    return async () => {

        const auth = inject(AuthService);
        const router = inject(Router);

        //
        // User must be authenticated
        //

        await auth.initialize();
        if (!auth.authenticated) {

            console.log(
                'AUTH GUARD: not authenticated'
            );
            return router.parseUrl('/');

        }

        //
        // Roles
        //

        if (options.roles?.length) {

            const matches = options.requireAll
                ? options.roles.every(role => auth.hasRole(role))
                : options.roles.some(role => auth.hasRole(role));

            if (!matches) {
                return router.parseUrl('/access-denied');
            }
        }

        //
        // Permissions
        //

        if (options.permissions?.length) {

            const matches = options.requireAll
                ? options.permissions.every(permission => auth.hasPermission(permission))
                : options.permissions.some(permission => auth.hasPermission(permission));

            if (!matches) {
                return router.parseUrl('/access-denied');
            }
        }

        return true;
    };
}